import { render, staticRenderFns } from "./tiaoz.vue?vue&type=template&id=191b8a20&scoped=true&"
import script from "./tiaoz.vue?vue&type=script&lang=js&"
export * from "./tiaoz.vue?vue&type=script&lang=js&"
import style0 from "./tiaoz.vue?vue&type=style&index=0&id=191b8a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b8a20",
  null
  
)

export default component.exports